import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus, Pencil, Eye, EyeOff, Trash2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { api, egp, errMsg, mediaUrl } from "@/lib/api";
import { ACard, AH1, ABtn } from "./ui";

export default function AdminCourses() {
  const [list, setList] = useState([]);
  const nav = useNavigate();
  const load = () => api.get("/admin/courses").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    try {
      const { data } = await api.post("/admin/courses", { title: "كورس جديد", published: false });
      nav(`/admin/courses/${data.id}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const togglePub = async (c) => {
    await api.patch(`/admin/courses/${c.id}/publish?published=${!c.published}`);
    toast.success(c.published ? "تم إلغاء النشر" : "تم النشر");
    load();
  };
  const del = async (c) => {
    if (!window.confirm(`حذف "${c.title}" وكل دروسه؟`)) return;
    await api.delete(`/admin/courses/${c.id}`);
    toast.success("تم الحذف");
    load();
  };

  return (
    <div data-testid="admin-courses">
      <AH1 action={<ABtn onClick={create} data-testid="admin-new-course-btn"><Plus size={16} />كورس جديد</ABtn>}>الكورسات</AH1>
      <div className="space-y-3">
        {list.map((c) => (
          <ACard key={c.id} className="flex flex-col md:flex-row md:items-center gap-4" data-testid={`admin-course-row-${c.id}`}>
            {c.cover_image ? <img src={mediaUrl(c.cover_image)} alt="" className="w-full md:w-32 aspect-video object-cover rounded-xl" /> : <div className="w-full md:w-32 aspect-video rounded-xl bg-white/5" />}
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-white truncate">{c.title}</p>
              <p className="text-xs text-slate-400 mt-1">{egp(c.price)} • {c.lessons_count} درس • {c.students_count} طالب {c.is_demo && <span className="text-yellow-300">• تجريبي</span>}</p>
            </div>
            <span className={`text-xs px-2.5 py-1 rounded-full w-fit ${c.published ? "bg-emerald-400/15 text-emerald-300" : "bg-white/10 text-slate-400"}`} data-testid={`admin-course-status-${c.id}`}>{c.published ? "منشور" : "مسودة"}</span>
            <div className="flex gap-2">
              <ABtn variant="ghost" onClick={() => togglePub(c)} data-testid={`admin-toggle-publish-${c.id}`}>{c.published ? <EyeOff size={15} /> : <Eye size={15} />}{c.published ? "إلغاء النشر" : "نشر"}</ABtn>
              <Link to={`/admin/courses/${c.id}`} data-testid={`admin-edit-course-${c.id}`}><ABtn variant="ghost"><Pencil size={15} />تعديل</ABtn></Link>
              <a href={`/courses/${c.slug}`} target="_blank" rel="noreferrer"><ABtn variant="ghost" aria-label="عرض"><ExternalLink size={15} /></ABtn></a>
              <ABtn variant="danger" onClick={() => del(c)} data-testid={`admin-delete-course-${c.id}`} aria-label="حذف"><Trash2 size={15} /></ABtn>
            </div>
          </ACard>
        ))}
        {list.length === 0 && <p className="text-slate-500">لا توجد كورسات.</p>}
      </div>
    </div>
  );
}
